var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { StickyListContextProvider, StickyListContextConsumer } from "../../layout-context";
import { TableContainer, TableBody } from "../table-container";
import { TableHead } from "../table-head";
import { StyledFixedList, StyledVariableList } from "./styled";
var ItemWrapper = function (_a) {
    var data = _a.data, index = _a.index, style = _a.style;
    var ItemRenderer = data.ItemRenderer;
    return React.createElement(ItemRenderer, { index: index, style: style, data: data });
};
var innerElementType = forwardRef(
// width shouldn't be taken from react-window prop source
function (_a, ref) {
    var children = _a.children, _b = _a.style, width = _b.width, restStyles = __rest(_b, ["width"]), rest = __rest(_a, ["children", "style"]);
    return (React.createElement(StickyListContextConsumer, null, function (_a) {
        var getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, hideHeader = _a.hideHeader, sortableBy = _a.sortableBy, className = _a.className, customProps = _a.customProps, layoutType = _a.layoutType;
        return (React.createElement(TableContainer, __assign({ style: restStyles, layoutType: layoutType, hideHeader: hideHeader }, getTableProps(), { className: className, callbackRef: ref }),
            !hideHeader && (React.createElement(TableHead, { headerGroups: headerGroups, sortableBy: sortableBy, customProps: customProps })),
            React.createElement(TableBody, __assign({ layoutType: layoutType }, getTableBodyProps()), children)));
    }));
});
export var StickyVirtualList = function (_a) {
    var children = _a.children, getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, hideHeader = _a.hideHeader, sortableBy = _a.sortableBy, className = _a.className, customProps = _a.customProps, layoutType = _a.layoutType, variableSize = _a.variableSize, callbackRef = _a.callbackRef, itemKey = _a.itemKey, orderedRows = _a.orderedRows, rest = __rest(_a, ["children", "getTableProps", "getTableBodyProps", "headerGroups", "hideHeader", "sortableBy", "className", "customProps", "layoutType", "variableSize", "callbackRef", "itemKey", "orderedRows"]);
    return (React.createElement(StickyListContextProvider, { value: {
            ItemRenderer: children,
            getTableProps: getTableProps,
            getTableBodyProps: getTableBodyProps,
            headerGroups: headerGroups,
            hideHeader: hideHeader,
            sortableBy: sortableBy,
            className: className,
            customProps: customProps,
            layoutType: layoutType,
        } }, variableSize ? (React.createElement(StyledVariableList, __assign({ itemData: { ItemRenderer: children, orderedRows: orderedRows }, ref: callbackRef, itemKey: itemKey }, rest), ItemWrapper)) : (React.createElement(StyledFixedList, __assign({ itemData: { ItemRenderer: children, orderedRows: orderedRows }, ref: callbackRef, itemKey: itemKey }, rest), ItemWrapper))));
};
// TODO - decide if we want to expose innerElementType
// Right now we assume, that we only want to virtualize existing table component,
// not a multiple different components with different design specs
StickyVirtualList.defaultProps = {
    innerElementType: innerElementType,
};
